import React, { useState } from 'react';
import './EditProduct.scss';

const EditProduct = () => {
  const [formData, setFormData] = useState({
    name: '',
    category: '',
    subCategory: '',
    discount: '',
    price: '',
    description: '',
    status: 'active',
    image: null,
  });

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'file' ? files[0] : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Submitted data:', formData);
  };

  return (
    <div className="edit-product-container">
      <div className="edit-product-box">
    

        <form onSubmit={handleSubmit}>
          <div className="form-grid">
            <div className="left-column">
              <div className="image-upload">
                <label htmlFor="image">
                  {formData.image ? (
                    <img src={URL.createObjectURL(formData.image)} alt="Preview" />
                  ) : (
                    <div className="upload-placeholder">
                      <span>Upload</span>
                      <p>W250 x H300</p>
                    </div>
                  )}
                </label>
                <input id="image" type="file" name="image" onChange={handleChange} />

                <div className="thumbnails">
                  <div className="thumb-box"></div>
                  <div className="thumb-box"></div>
                  <div className="thumb-box">+</div>
                </div>

                <div className="inputs">
                  <input type="text" placeholder="107" />
                  <input type="text" placeholder="EGP143" />
                </div>
              </div>

              <div className="status-options">
                <label className="custom-checkbox">
                  <input
                    type="checkbox"
                    name="status"
                    value="active"
                    checked={formData.status === 'active'}
                    onChange={handleChange}
                  />
                  <span className="checkmark"></span>
                  Active
                </label>
                <label className="custom-checkbox">
                  <input
                    type="checkbox"
                    name="status"
                    value="draft"
                    checked={formData.status === 'draft'}
                    onChange={handleChange}
                  />
                  <span className="checkmark"></span>
                  Draft
                </label>
              </div>
            </div>


            <div className="right-fields">
                  <div className="header">
          <h2>Edit Product</h2>
          <button className="close">×</button>
        </div>
              <input
                type="text"
                name="name"
                placeholder="Product Name"
                value={formData.name}
                onChange={handleChange}
                className='name'
              />

              <div className="row">
                <input
                  type="text"
                  name="category"
                  placeholder="Product Category"
                  value={formData.category}
                  onChange={handleChange}
                />
                <input
                  type="text"
                  name="subCategory"
                  placeholder="Sub Category"
                  value={formData.subCategory}
                  onChange={handleChange}
                />
              </div>

              <div className="row">
                <input
                  type="number"
                  name="discount"
                  placeholder="Discount %"
                  value={formData.discount}
                  onChange={handleChange}
                />
                <input
                  type="number"
                  name="price"
                  placeholder="Price"
                  value={formData.price}
                  onChange={handleChange}
                />
              </div>

              <textarea
                name="description"
                placeholder="Product Description"
                value={formData.description}
                onChange={handleChange}
                style={{
                  height:"150px"
                }}
              />

              <div className="form-buttons">
                <button type="submit" className="publish">
                  PUBLISH
                </button>
                <button type="button" className="cancel">
                  CANCEL
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditProduct;